export default __webpack_public_path__ + "static/media/hallmark-crown-golden.7c168e26.webp";